import { Box, Text, VStack } from '@chakra-ui/react'
import { FieldMapValue } from '@hb/shared'
import { SectionLabel } from '../../SectionLabel'

const LabelText = ({ label }: { label: string }) => (
  <Text fontSize="xs" fontWeight={600} color="gray.500" _dark={{ color: 'gray.400' }} mb={0.5}>
    {label}
  </Text>
)

const notScreenedReasonLabels: Record<string, string> = {
  'already-screened-this-trimester': 'Already screened this trimester',
  'patient-declined': 'Patient declined',
  'clinical-judgment': 'Clinical judgment',
}

export const DepressionScreeningView = ({ data }: { data: FieldMapValue }) => {
  const screening = data?.depressionScreening as
    | {
        addressed?: boolean
        tool?: string
        score?: number
        interpretation?: string
        followUpPlan?: string
        notScreenedReason?: string
      }
    | undefined

  if (!screening) return null

  const { addressed, tool, score, interpretation, followUpPlan, notScreenedReason } = screening

  return (
    <VStack align="flex-start" spacing={2} w="100%">
      <SectionLabel>Depression & Anxiety Screening</SectionLabel>

      {addressed === false && (
        <Text fontSize="sm" color="gray.500" _dark={{ color: 'gray.400' }}>
          Not screened today
          {notScreenedReason
            ? ` — ${notScreenedReasonLabels[notScreenedReason] ?? notScreenedReason}`
            : ''}
        </Text>
      )}

      {addressed === true && (
        <VStack align="flex-start" spacing={1.5} w="100%">
          {(tool || typeof score === 'number') && (
            <Text fontSize="sm">
              {tool ?? 'Screening'}
              {typeof score === 'number' ? ` — Score: ${score}` : ''}
            </Text>
          )}
          {interpretation && (
            <Box>
              <LabelText label="Interpretation" />
              <Text fontSize="sm" whiteSpace="pre-wrap">
                {interpretation}
              </Text>
            </Box>
          )}
          {followUpPlan && (
            <Box>
              <LabelText label="Follow-up plan" />
              <Text fontSize="sm" whiteSpace="pre-wrap">
                {followUpPlan}
              </Text>
            </Box>
          )}
        </VStack>
      )}
    </VStack>
  )
}
